import solver from 'solver-utilities';

const open = async function (event, id) {
	if (event) event.preventDefault();

	const delay = parseInt(solver.frontend.getCSSVariable('--animate-delay'));
	const _modal = document.querySelector(`[data-modal="${id}"]`);
	const dialog = _modal.querySelector('[data-modal-dialog]');

	_modal.classList.add('modal--active');

	await solver.each.asyncTimeout(delay);

	_modal.classList.add('animate__fadeIn');

	await solver.each.asyncTimeout(delay);

	dialog.classList.add('animate__fadeInDown');
};

const close = async function (event, id) {
	if (event) event.preventDefault();

	const delay = parseInt(solver.frontend.getCSSVariable('--animate-delay'));
	const _modal = document.querySelector(`[data-modal="${id}"]`);
	const dialog = _modal.querySelector('[data-modal-dialog]');

	dialog.classList.add('animate__fadeOutUp');

	await solver.each.asyncTimeout(delay);

	_modal.classList.add('animate__fadeOut');

	await solver.each.asyncTimeout(delay);

	_modal.classList.remove('modal--active', 'animate__fadeOut', 'animate__fadeIn');
	dialog.classList.remove('animate__fadeInDown', 'animate__fadeOutUp');
};

export const modal = function () {
	window.Solver.modal = {
		open,
		close
	};
};
